export default "__VITE_ASSET__44aebe3b__"